import {Dialog, Transition} from '@headlessui/react';
import {Fragment} from 'react';

interface ConfirmationModalProps {
  isOpen: boolean; // Status modal terbuka
  onClose: () => void; // Fungsi untuk menutup modal
  title: string; // Judul modal
  message: string; // Pesan yang ditampilkan di modal
  confirmText: string; // Teks untuk tombol konfirmasi
  cancelText: string; // Teks untuk tombol batal
  onConfirm: () => void; // Fungsi untuk aksi konfirmasi
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
                                                               isOpen,
                                                               onClose,
                                                               title,
                                                               message,
                                                               confirmText,
                                                               cancelText,
                                                               onConfirm,
                                                             }) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-[999]" onClose={onClose}>
        {/* Overlay Background */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/60"/>
        </Transition.Child>

        {/* Modal Content */}
        <div className="fixed inset-0 z-[1000] flex items-center justify-center px-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel
              className="panel border-0 p-0 rounded-lg overflow-hidden w-full max-w-md bg-white dark:bg-gray-800">
              {/* Modal Header */}
              <div className="p-5">
                <h5 className="text-lg font-bold text-gray-800 dark:text-white">{title}</h5>
                <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{message}</p>
              </div>

              {/* Modal Footer */}
              <div className="flex justify-end items-center p-5 space-x-3">
                <button
                  onClick={() => {
                    console.log('Cancel button clicked');
                    onClose();
                  }}
                  className="btn btn-outline-danger"
                >
                  {cancelText}
                </button>
                <button
                  onClick={() => {
                    console.log('Confirm button clicked');
                    onConfirm();
                  }}
                  className="btn btn-primary"
                >
                  {confirmText}
                </button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ConfirmationModal;
